<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="450"
  >
    <v-card v-if="user">
      <v-card-title class="headline">
        {{ $t('message.edit_user_dialog_title') }}
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="user.role"
          :items="user_roles"
          item-value="id"
          item-text="title"
          :label="($t('message.select_user_role') + ' *')"
        />
        <v-select
          v-model="user.subscription"
          :items="userSubscriptions"
          item-value="id"
          item-text="title"
          :label="($t('message.select_user_subscription') + ' *')"
        />
        <v-checkbox
          v-model="user.active"
          :label="$t('message.is_user_active')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click="show = false"
        >
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="$emit('confirm', user)"
        >
          {{ $t('message.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// UserRoleAndSubscriptionMixin
let mixin = {
  data: (vm) => ({
    user_roles: [
      { id: 'owner', title: vm.$t('message.user_role_owner') },
      { id: 'collaborator', title: vm.$t('message.user_role_collaborator') },
      { id: 'consultant', title: vm.$t('message.user_role_consultant') },
      { id: 'student', title: vm.$t('message.user_role_student') },
    ],
    user_subscriptions: [
      { id: 'standard', title: vm.$t('message.user_subscription_standard') },
      { id: 'extensive', title: vm.$t('message.user_subscription_extensive') },
      { id: 'watch', title: vm.$t('message.user_subscription_watch') },
      { id: 'student', title: vm.$t('message.user_subscription_student') },
    ],
  }),
}
export default {
  mixins: [mixin],
  props: {
    value: Boolean,
    disabled: Boolean,
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  computed: {
    show: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    userSubscriptions() {
      switch (this.user.role) {
      case 'owner':
        return this.user_subscriptions.filter((r) => r.id != 'watch')
        break
      case 'consultant':
        return this.user_subscriptions.filter(
          (r) => r.id == 'watch' || r.id == 'student'
        )
        break
      case 'student':
        return this.user_subscriptions.filter((r) => r.id == 'student')
        break
      default:
        return this.user_subscriptions
      }
    },
  },
  // , validations: {
  //   user: {
  //     role: {
  //       required
  //     },
  //     subscription: {
  //       required
  //     }
  //   }
  // }
}
</script>
